/// <amd-module name="Repos/Views/PushDetails/RestClient/Git" />
/**
 * ---------------------------------------------------------
 * Generated file, DO NOT EDIT
 * ---------------------------------------------------------
 *
 * See following wiki page for instructions on how to regenerate:
 *   https://aka.ms/azure-devops-client-generation
 *
 * Configuration file:
 *   tfs\web\extensions\code\vss-code-web\repos\views\push-details\genclient.json
 */

import { IVssPageContext, IVssRestClient, IVssRestClientOptions, RestClients } from "VSS/Platform/Context";
import { RestClientBase } from "VSS/Platform/RestClientBase";

import * as Git from "Repos/Common/Contracts/Git";

export interface IGitRestClient extends IVssRestClient {
    /**
     * Retrieves a particular push.
     * 
     * @param repositoryId - The name or ID of the repository.
     * @param pushId - ID of the push.
     * @param project - Project ID or project name
     * @param includeCommits - The number of commits to include in the result.
     * @param includeRefUpdates - If true, include the list of refs that were updated by the push.
     */
    getPush(repositoryId: string, pushId: number, project?: string, includeCommits?: number, includeRefUpdates?: boolean): Promise<Git.GitPush>;
}

class GitRestClient extends RestClientBase implements IGitRestClient {
    constructor(options: IVssRestClientOptions) {
        super(options);
    }

    /**
     * Retrieves a particular push.
     * 
     * @param repositoryId - The name or ID of the repository.
     * @param pushId - ID of the push.
     * @param project - Project ID or project name
     * @param includeCommits - The number of commits to include in the result.
     * @param includeRefUpdates - If true, include the list of refs that were updated by the push.
     */
    public async getPush(
        repositoryId: string,
        pushId: number,
        project?: string,
        includeCommits?: number,
        includeRefUpdates?: boolean
        ): Promise<Git.GitPush> {

        const queryValues: any = {
            includeCommits: includeCommits,
            includeRefUpdates: includeRefUpdates
        };

        return this.beginRequest<Git.GitPush>({
            apiVersion: "5.0-preview.2",
            routeTemplate: "{project}/_apis/git/repositories/{repositoryId}/pushes/{pushId}",
            routeValues: {
                project: project,
                repositoryId: repositoryId,
                pushId: pushId
            },
            queryParams: queryValues
        });
    }

}

export const GitClientName = "Repos.PushDetailsHub.IGitRestClient";

export function getGitClient(pageContext: IVssPageContext, options?: IVssRestClientOptions): IGitRestClient {
    return pageContext.getRestClient<IGitRestClient>(GitClientName, options);
}

RestClients.add(GitClientName, { 
    factory: GitRestClient,
    options: {
        resourceAreaId: "4e080c62-fa21-4fbc-8fef-2a10a2b38049",
        serviceInstanceType: "00025394-6065-48ca-87d9-7f5672854ef7"
    }
});
